import React, { useEffect, useRef, useCallback } from "react";
import styles from "./SuggestPopup.module.scss";
import { Command } from "../../../../../types/types";

type Props = {
  children: React.ReactNode;
  actionType?: Command;
  setPopup?: React.Dispatch<React.SetStateAction<{ isVisible: boolean }>>;
  ignoreRef?: React.RefObject<HTMLDivElement | HTMLInputElement>;
};

const SuggestPopup = ({ children, actionType, setPopup, ignoreRef }: Props) => {
  const suggestPopupRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = useCallback(
    (event: MouseEvent) => {
      if (
        suggestPopupRef.current &&
        !suggestPopupRef.current.contains(event.target as Node) &&
        (!ignoreRef || !ignoreRef.current || !ignoreRef.current.contains(event.target as Node))
      ) {
        setPopup?.({ isVisible: false });
      }
    },
    [setPopup, ignoreRef],
  );

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div
      className={styles.suggestPopup}
      style={{ top: actionType && actionType === "fill" ? "160px" : "90px" }}
      ref={suggestPopupRef}
    >
      {children}
    </div>
  );
};

export default SuggestPopup;
